<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.regional.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRegionais" }'
    )
    .formulario-regional
        h3.formulario-regional__titulo {{ $t('mensagens.regional.labels.dadosCadastrais') }}
        .formulario-regional__card
            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.regional.labels.nome') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.regional.labels.descricao")',
                    v-model='gerenteRegional.nome'
                )
        h3.formulario-regional__titulo {{ $t('mensagens.regional.labels.dadosVinculados') }}
        .formulario-regional__card.handler
            FormularioHandler(:titulo='tituloGerenteRegional()')
                MultiselectTable(
                    tableId='gerentes-regionais-table',
                    :label='formatarGerenteRegional()',
                    v-model='idsGerentesRegionais',
                    :options='gerentesRegionais',
                    :loading='carregandoGerentesRegionais',
                    :buttonAddLabel='$t("mensagens.regional.labels.adicionarGerenteRegional")',
                    :buttonRouteLabel='$t("mensagens.regional.labels.criarGerenteRegional")',
                    :alertMessageAdd='$t("mensagens.regional.labels.alertaAdicionarGerenteRegional")',
                    routeName='GerenteRegionalCadastro'
                )
        .formulario-regional__card.handler
            FormularioHandler(:titulo='tituloGerenteComercial()')
                MultiselectTable(
                    tableId='gerentes-comerciais-table',
                    :label='formatarGerenteComercial()',
                    v-model='idsGerentesComerciais',
                    :options='gerentesComerciais',
                    :loading='carrengandoGerentesComerciais',
                    :buttonAddLabel='$t("mensagens.regional.labels.adicionarGerenteComercial")',
                    :buttonRouteLabel='$t("mensagens.regional.labels.criarGerenteComercial")',
                    :alertMessageAdd='$t("mensagens.regional.labels.alertaAdicionarGerenteComercial")',
                    routeName='GerentesComerciaisCadastro'
                )
        .formulario-regional__card.handler
            FormularioHandler(:titulo='tituloGerenteTerritorial()')
                MultiselectTable(
                    tableId='gerentes-territoriais-table',
                    :label='formatarGerenteTerritorial()',
                    v-model='idsGerentesTerritoriais',
                    :options='gerentesTerritoriais',
                    :loading='carregandoGerentesTerritoriais',
                    :buttonAddLabel='$t("mensagens.regional.labels.adicionarGerenteTerritorial")',
                    :buttonRouteLabel='$t("mensagens.regional.labels.criarGerenteTerritorial")',
                    :alertMessageAdd='$t("mensagens.regional.labels.alertaAdicionarGerenteTerritorial")',
                    routeName='CadastroGerenteTerritorial'
                )
        .footer
            .footer__btn.voltar(@click='irParaRegionais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='fluxoSalvarRegional')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'FormularioRegional',
    props: ['row'],
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        FormularioHandler: () =>
            import('@/components/contratosOriginacao/formulario/Handler'),
        MultiselectTable: () =>
            import(
                '@/components/contratosOriginacao/formulario/MultiselectTable'
            )
    },
    data() {
        return {
            gerentesRegionais: [],
            gerentesTerritoriais: [],
            gerentesComerciais: [],
            idsGerentesRegionais: [],
            idsGerentesTerritoriais: [],
            idsGerentesComerciais: [],
            gerenteRegional: {
                id: '',
                nome: '',
                idsGerentesRegionais: '',
                idsGerentesComerciais: '',
                idsGerentesTerritoriais: ''
            },
            carrengandoGerentesComerciais: true,
            carregandoGerentesTerritoriais: true,
            carregandoGerentesRegionais: true
        };
    },

    mounted() {
        this.carregarListasGerentes();
    },
    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            await this.buscarGerentesTerritoriais();
            await this.buscarGerentesRegionais();
            await this.buscarGerentesComerciais();
            this.preencherCamposEdicao();
            this.loadingScreen(false);
        },
        preencherCamposEdicao() {
            if (this.row?.id) {
                this.gerenteRegional = {
                    id: this.row.id,
                    nome: this.row.nome,
                    idsGerentesRegionais: this.row?.idsGerentesRegionais,
                    idsGerentesTerritoriais: this.row?.idsGerentesTerritoriais,
                    idsGerentesComerciais: this.row?.idsGerentesComerciais
                };
                this.idsGerentesTerritoriais =
                    this.row?.idsGerentesTerritoriais || [];
                this.idsGerentesComerciais =
                    this.row?.idsGerentesComerciais || [];
                this.idsGerentesRegionais =
                    this.row?.idsGerentesRegionais || [];
            }
        },
        buscarGerentesRegionais() {
            return services.buscarGerentesRegionais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesRegionais = data;
                    this.carregandoGerentesRegionais = false;
                }
            });
        },
        buscarGerentesTerritoriais() {
            return services.buscarGerentesTerritoriais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesTerritoriais = data;
                    this.carregandoGerentesTerritoriais = false;
                }
            });
        },
        buscarGerentesComerciais() {
            return services.buscarGerentesComerciais().then(({ data }) => {
                if (data.length > 0) {
                    this.carrengandoGerentesComerciais = false;
                    this.gerentesComerciais = data;
                }
            });
        },
        irParaRegionais() {
            this.$router.push({ name: 'ConfiguracaoRegionais' });
        },
        fluxoSalvarRegional() {
            const nomeInvalido = !this.gerenteRegional.nome;
            const mensagemNomeVazio = this.$t(
                'mensagens.regional.labels.nomeVazio'
            );

            if (nomeInvalido) {
                return this.$notify.error(mensagemNomeVazio);
            }
            if (this.row?.id) {
                this.editarRegional();
            } else {
                this.cadastrarRegional();
            }
        },
        cadastrarRegional() {
            const mensagemSucesso = this.$t(
                'mensagens.regional.labels.registroCadastrado'
            );
            let params = { nome: this.gerenteRegional.nome };

            if (this.idsGerentesTerritoriais.length > 0) {
                params.idsGerentesTerritoriais = this.idsGerentesTerritoriais;
            }
            if (this.idsGerentesComerciais.length > 0) {
                params.idsGerentesComerciais = this.idsGerentesComerciais;
            }
            if (this.idsGerentesRegionais.length > 0) {
                params.idsGerentesRegionais = this.idsGerentesRegionais;
            }
            return services.cadastraRegional(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaRegionais();
            });
        },
        editarRegional() {
            const mensagemSucesso = this.$t(
                'mensagens.regional.labels.registroEditado'
            );
            let params = {
                id: this.gerenteRegional.id,
                nome: this.gerenteRegional.nome
            };

            if (this.idsGerentesTerritoriais.length > 0) {
                params.idsGerentesTerritoriais = this.idsGerentesTerritoriais;
            }
            if (this.idsGerentesComerciais.length > 0) {
                params.idsGerentesComerciais = this.idsGerentesComerciais;
            }
            if (this.idsGerentesRegionais.length > 0) {
                params.idsGerentesRegionais = this.idsGerentesRegionais;
            }
            return services.editaRegional(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaRegionais();
            });
        },
        tituloGerenteRegional() {
            const gerentesRegionais = this.$t(
                'mensagens.regional.labels.gerentesRegionais'
            );
            const opcional = this.$t('mensagens.regional.labels.opcional');

            return `${gerentesRegionais} (${opcional})`;
        },
        tituloGerenteTerritorial() {
            const gerentesTerritoriais = this.$t(
                'mensagens.regional.labels.gerentesTerritoriais'
            );
            const opcional = this.$t('mensagens.regional.labels.opcional');

            return `${gerentesTerritoriais} (${opcional})`;
        },
        tituloGerenteComercial() {
            const gerentesComerciais = this.$t(
                'mensagens.regional.labels.gerentesComerciais'
            );
            const opcional = this.$t('mensagens.regional.labels.opcional');

            return `${gerentesComerciais} (${opcional})`;
        },
        formatarGerenteRegional() {
            return this.idsGerentesTerritoriais.length > 1
                ? this.$t('mensagens.regional.labels.gerentesRegionais')
                : this.$t('mensagens.regional.labels.gerenteRegional');
        },
        formatarGerenteTerritorial() {
            return this.idsGerentesTerritoriais.length > 1
                ? this.$t('mensagens.regional.labels.gerentesTerritoriais')
                : this.$t('mensagens.regional.labels.gerenteTerritorial');
        },
        formatarGerenteComercial() {
            return this.idsGerentesTerritoriais.length > 1
                ? this.$t('mensagens.regional.labels.gerentesComerciais')
                : this.$t('mensagens.regional.labels.gerenteComercial');
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss">
.formulario-regional {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        &.handler {
            padding: 0;
        }
    }
    .select-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            border-radius: $default-border-radius;
            outline: 0;
            & input {
                color: var(--primary-font-color) !important;
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }
    .input-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            width: 100%;
            border-radius: $default-border-radius;
            border: 1px solid $default-border-color;
            outline: 0;
            padding: 0 15px;
        }
    }
    .obrigatorio::after {
        content: '* ';
        color: red;
        margin-left: 3px;
    }
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 8px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
